import { MissionData } from '../blocks/mission'
import template from './templates/RJS10.rbxl'
import thumbnail1 from './thumbnails/RJS10/BlueBlock.png'
import thumbnail2 from './thumbnails/RJS10/RedBlock.png'
import thumbnail3 from './thumbnails/RJS10/GreenBlock.png'
import thumbnail4 from './thumbnails/RJS10/SpawnLocation.png'
import thumbnail5 from './thumbnails/RJS10/BlueBall.png'
import thumbnail6 from './thumbnails/RJS10/RedBall.png'
import thumbnail7 from './thumbnails/RJS10/GreenBall.png'
import thumbnail8 from './thumbnails/RJS10/Goal.png'
import thumbnail9 from './thumbnails/RJS10/Wall.png'
const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}, {}],
  objects: [
    {
      name: '①あおいブロック',
      thumbnail: thumbnail1,
    },
    {
      name: '②あかいブロック',
      thumbnail: thumbnail2,
    },
    {
      name: '③みどりのブロック',
      thumbnail: thumbnail3,
    },
    {
      name: '④スタートちてん',
      thumbnail: thumbnail4,
    },
    {
      name: '⑤あおいボール',
      thumbnail: thumbnail5,
    },
    {
      name: '⑥あかいボール',
      thumbnail: thumbnail6,
    },
    {
      name: '⑦みどりのボール',
      thumbnail: thumbnail7,
    },
    {
      name: '⑧ゴール',
      thumbnail: thumbnail8,
    },
    {
      name: '⑨かべ',
      thumbnail: thumbnail9,
    },
  ],
}

export default mission
